import ApiUrl from "services/shared/ApiUrl";

export const msgTypes = {
    LOCALHOST: 'localhost',
    APP_SECRET_KEY:
    {
        KEY: "ACC62A67A3D055E6AF68BD9D3ED9A519",
        IV: "608538a015674f17"
    },
//   For local key
    // GOOGLE_CAPTCHA_SITE_KEY_LOCAL: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    // GOOGLE_CAPTCHA_SITE_KEY_PROD: '6LfIXD4qAAAAAAWNjWp8RG4wSmM1x0mm5i8nAxZ5',
    // GOOGLE_CAPTCHA_SECRET_KEY_LOCAL: '6LfIXD4qAAAAAMqs2lFdQov6uqsNWWdu45IEdWY6',

// For Production Key
    GOOGLE_CAPTCHA_SITE_KEY_LOCAL: '6LeuEk0rAAAAAPBcmvSO2jtEs9YdPi-UuiN6g3ra',
    GOOGLE_CAPTCHA_SITE_KEY_PROD: '6LeuEk0rAAAAAPBcmvSO2jtEs9YdPi-UuiN6g3ra',
    GOOGLE_CAPTCHA_SECRET_KEY_PRODUCTION: '6LeuEk0rAAAAAGs0EhQw1pk1cp2dwnI6OeZYb8_g',
    

    SUCCESS: {
        code: "1000",
        msg: "SUCCESS"
    },

    USER_TYPE:{
        ADMIN:"ADMIN",
        MEMBER:"MEMBER"
    },

    DOCUMENT_TYPE: {
        JPG: "jpg",
        JPEG: "jpeg",
        PNG: "png",
        PDF: "pdf",
        TXT: "txt",
        XLSX: "xlsx",
        CSV: "csv"
    },

    YES: "Yes",
    NO: "No",

    //Image Format
    ALL_EXTENSIONS: ".jpg,.jpeg,.png,.svg,.webp,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar,.7z",
    SUPPORTED_IMAGE_FORMAT:["image/jpg","image/jpeg","image/png"],
    SUPPORTED_IMAGE_PDF:["image/jpg","image/jpeg","image/png","application/pdf",],
    SUPPORTED_ALL_FORMAT:["image/jpg","image/jpeg","image/png","application/pdf", "application/msword"],
    SUPPORTED_ONLY_PDF:["application/pdf"],
    IMAGE_EXTENSIONS:["jpg","jpeg","png"],
    IMAGE_FORMAT : {
        JPEG: "image/jpeg",
        JPG: "image/jpg",
        PNG: "image/png",
        SVG: "application/svg",
        WEBP: "application/webp",
        PDF: "application/pdf",
        WORD: "application/doc",
        EXCEL: "application/xlsx",
        CSV: "application/csv",
       
    },

    //Image Size 
    FILE_SIZE_1MB: 1 * 1024 * 1024,
    FILE_SIZE_3MB: 3 * 1024 * 1024,

    //Image validation message
    IMAGE_UNSUPPORTED_FORMAT: "Uploaded file format is unsupported",
    FILE_SIZE_MESSAGE_1MB : "File size should be less then 1mb",
    FILE_SIZE_MESSAGE_3MB : "File size should be less then 3mb",
    IMAGE_UNSUPPORTED_FORMATS: "Only pdf supported",
    FILE_SIZE_ALLOW_1MB : "Size less than 1mb",
    FILE_SIZE_ALLOW_3MB : "Size less than 3mb",
    
    APPLICATION_JSON: "application/json",
    ACCESS_TOKEN: "accessToken",
    USER_DETAILS: "userDetails",
    ROLE: "role",

    BASIC_ACCESS_TOKEN: "basicAccessToken",
    STORE_INFO: "userName",

    //status
    //SUCCESS : 'SUCCESS',

    //regex related constant
    RESPONSE_CODE_REGEX: new RegExp("^[1]{1}[0-9]{3}$"),
    RESPONSE_CODE_REGEX_THREE_DIGITS: new RegExp("^[0-1]{1}[0-9]{2}$"),

    // Login Page
    LOGIN_SUCCESS: "Login Successful",
    LOGGED_OUT: "Logout Successful",
    SOMETHING_WENT_WRONG: "Something went wrong",

    //Sweet alert 
    success: "success",
    error: "error",
    OK_KEY: 'OK',

    //Generate Form
    EMPTY_STR: '',

    //Curl strings
    HOST_URL: "HostUrl: ",
    METHOD_TYPE: "MethodType: ",
    REQUEST: "request: ",
    HEADERS_MAP: "HeadersMap: ",

    //Begin:: Table ColumnDef and Headers
    COLUMNDEF_APPROVE: 'approve',
    COLUMNDEF_REJECT: 'reject',
    HEADER_APPROVE: 'Approve',
    HEADER_REJECT: 'Reject',
    HEADER_ACTION: 'Action',

    //End:: Table ColumnDef and Headers
    
    
    VIEW: "view",
    EDIT: "edit",

    //Conformation Alert msg
    CONFORMATION_MESSAGE: {
        UPDATE_RECORD:'Update Record',
        DELETE_RECORD: 'Delete Record',
        LOGOUT : 'Logout'
    },

    CONFORMATION_ICON:{
        WARNING: 'warning',
        ERROR: 'error'
    },


    CAROUSEL_SETTINGS: {
        // dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    // dots: true
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: true,
                    // dots: true
                }
            },
            {
              breakpoint: 992,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  initialSlide: 1,
                  infinite: true,
                //   dots: true
              }
          },
            {
              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 1,
                  infinite: true,
                //   dots: true
              }
          }
        ]
    },


    INVOICE_STATUS : {
        PAID: "Paid",
        OUTSTANDING: "Outstanding",
        OVERDUE: "Overdue" 
    },


    INVOICE_STATUS_COUNT : {
        PAID: "paidCount",
        OUTSTANDING: "outstandingCount",
        OVERDUE: "overdueCount" 
    },

    MEMBERSHIP_TYPE:{
            EXCLUSIVE: "exclusive",
            FOUNDER: "founder"
            
    },


    WEBSITE_URL:{
        HOME:ApiUrl.websiteUrl+"/",
        ABOUT:ApiUrl.websiteUrl+"/about-us",
        MEMBERSHIP_BENEFITS:ApiUrl.websiteUrl+"/membership-benifits",
        MEMBERSHIP_REGISTRATION:ApiUrl.websiteUrl+ "/membership-form",
        CONTACT_US:ApiUrl.websiteUrl+"/contact"
    },

    UNREAD_MESSAGE:"Unread Message",
    UNREAD_INVOICE:"Unread Invoice",
    
    IMAGE_SIZE:{
        XSMALL:"Extra-Small",
        SMALL: "Small-Image",
        MEDIUM: "Medium-Image",
        LARGE:"Large-Image"
    },


    TEXT_EDITOR_MODULE: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          ["link", "image", "video", "formula"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ font: [] }],
          [{ align: [] }],
          ["clean"],
        ],
      }


}